<script>
import {delLocalItem, getLocalItem} from "@/untils/common";
import {logoutRequest} from "@/lib/request";
export default {
  name:'techMy',
  data(){
    return{
      nickName:'',
      postName:'',
      phone:'',
      roles:'',
      area:'',
      deptName:'',
      keys:0,
    }
  },
  methods:{
    logout(){
      logoutRequest().then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              delLocalItem('roles');
              delLocalItem('phone');
              delLocalItem('postName');
              delLocalItem('deptName');
              console.log(getLocalItem('open_id'))
              if(getLocalItem('open_id')){
                delLocalItem('local_role');
                this.$router.push({path: '/login',query:{openid: getLocalItem('open_id')}})
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
  },
  created(){
    let nickName = getLocalItem('nickName');
    // let postName = getLocalItem('postName');
    let phone = getLocalItem('phone');
    let roles = getLocalItem('roles');
    let deptName = getLocalItem('deptName');
    let arr_list = ['专管员','维修员']
    arr_list.map((v,k)=>{
      if(roles.indexOf(v)!==-1){
        this.index = k;
      }
    });
    this.roles = arr_list[this.index];
    let arr = ['拉萨','日喀则','山南','林芝','昌都','那曲','阿里'];
    arr.map((v,k)=>{
      if(roles.indexOf(v)!==-1){
        this.keys = k;
      }
    });
    this.area = arr[this.keys]
    if(nickName){
      this.nickName = nickName;
    }
    if(roles){
      this.postName = roles;
    }
    if(phone){
      this.phone = phone;
    }
    if(deptName){
      this.deptName = deptName;
    }
  }
}
</script>

<template>
  <!-- 页面：我的 -->
  <div id="myPage">
    <div class="tech-content">
      <div class="card">
        <div style="display: flex; padding: 15px 0;">
          <div style="width: 60px; height: 60px; background-color: #f5f5f5; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #999;">
            &#128100;
          </div>
          <div style="margin-left: 15px; flex: 1;">
            <div style="font-size: 18px; font-weight: bold; margin-bottom: 5px;">{{nickName}}</div>
            <div style="font-size: 14px; color: #666;"> {{ deptName }} | {{ postName }}</div>
            <div class="logout" @click="logout">退出</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-title">人员信息</div>
        <div class="info-item">
          <div class="info-label">姓名</div>
          <div class="info-value">{{ nickName }}</div>
        </div>
        <!--        <div class="info-item">-->
        <!--          <div class="info-label">联系电话</div>-->
        <!--          <div class="info-value">{{ phone }}</div>-->
        <!--        </div>-->
        <div class="info-item">
          <div class="info-label">所属部门</div>
          <div class="info-value">{{ deptName }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">职位</div>
          <div class="info-value">{{ postName }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">工作区域</div>
          <div class="info-value">{{ area }}市</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tech-content{
  padding-top: 120px;
  box-sizing: border-box;
}
.logout{
  display: inline-block;
  margin-top: 20px;
  padding: 8px 30px;
  color: #fff;
  background: #e62d2d;
  border: 1px solid #e62d2d;
  border-radius: 10px;
}
</style>